import React from 'react'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const SearchByComponent = ({value,handleRadioButtonChange,isChangeLog=false}) => {
  return (
    <FormControl>
        <FormLabel id="demo-row-radio-buttons-group-label">Search By:</FormLabel>
        <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={value}
            onChange={handleRadioButtonChange}
        >
            <FormControlLabel value="0" control={<Radio size="small" />} label="Genset Serial Number" />
            {!isChangeLog &&
              <FormControlLabel value="1" control={<Radio size="small" />} label="Controller Serial Number" />
            }
            { isChangeLog &&
              <FormControlLabel value="2" control={<Radio size="small" />} label="Username (Email)" />
            }
        </RadioGroup>
    </FormControl>
  )
}

export default SearchByComponent